import { useState } from "react";
import axios from "axios";
import { Upload, Send, FileText, User, Tag, Layers, X, Calendar } from "lucide-react"; 
import "./AddMemoire.css";

export default function AddMemoire() {
  const [form, setForm] = useState({
    intitule_M: "", 
    intitule_R: "", 
    Ecrivain: "",
    annee: "", 
    resume_M: "", 
    resume_R: "", 
    mots_cles: "", 
    Axes: ""
  });

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));
    if (image) formData.append("Couverture_R", image);

    try {
      // 1. RÉCUPÉRER LE TOKEN DEPUIS LE LOCALSTORAGE
      const token = localStorage.getItem("token");

      // 2. ENVOYER LE TOKEN DANS LA REQUÊTE
      const res = await axios.post("https://api.memofacdz.com/api/memoires", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Important pour l'image
          "Authorization": `Bearer ${token}`    // LE BADGE DE SÉCURITÉ
        }
      });

      alert("Mémoire enregistré avec succès ! ✨");
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.message || "Erreur lors de l'envoi.";
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-main">
      <div className="card">
        <div className="header">
          <h1>Nouveau Mémoire</h1>
          <p>Gestion de la base de données documentaire</p>
        </div>

        <form onSubmit={handleSubmit} className="form-grid">
          {/* Colonne Gauche */}
          <div className="form-column">
            <div className="input-group">
              <label>intitulé memoire</label>
              <div className="input-wrapper">
                <FileText className="icon" size={18} />
                <input name="intitule_M" placeholder="Ex: L'impact de l'IA..." onChange={handleChange} required />
              </div>
            </div>

            <div className="input-group">
              <label>Intitulé Roman</label>
              <div className="input-wrapper">
                <FileText className="icon" size={18} />
                <input name="intitule_R" placeholder="Ex: AI Impact on..." onChange={handleChange} />
              </div>
            </div>

            <div className="input-group">
              <label>Auteur</label>
              <div className="input-wrapper">
                <User className="icon" size={18} />
                <input name="Ecrivain" placeholder="Nom complet" onChange={handleChange} required />
              </div>
            </div>

            {/* --- NOUVEAU CHAMP ANNÉE --- */}
            <div className="input-group">
              <label>Année de publication</label>
              <div className="input-wrapper">
                <Calendar className="icon" size={18} />
                <input 
                  type="number" 
                  name="annee" 
                  placeholder="Ex: 2024" 
                  min="1900" 
                  max="2099" 
                  onChange={handleChange} 
                  required 
                />
              </div>
            </div>

            <textarea name="resume_M" className="textarea-field" placeholder="Problématique" onChange={handleChange}></textarea>
            <textarea name="resume_R" className="textarea-field" placeholder="Résumé Roman" onChange={handleChange}></textarea>
          </div>

          {/* Colonne Droite */}
          <div className="form-column">
            <div className="input-group">
              <label>Métadonnées</label>
              <div className="input-wrapper" style={{marginBottom: '10px'}}>
                <Tag className="icon" size={18} style={{color: '#4f46e5'}} />
                <input name="mots_cles" placeholder="Mots-clés (IA, Tech...)" onChange={handleChange} />
              </div>
              <div className="input-wrapper">
                <Layers className="icon" size={18} style={{color: '#4f46e5'}} />
                <input name="Axes" placeholder="Axes de recherche" onChange={handleChange} />
              </div>
            </div>

            <div className="upload-container">
              <label style={{fontSize: '11px', fontWeight: 'bold', color: '#6b7280', display: 'block', marginBottom: '5px'}}>COUVERTURE</label>
              <div className="upload-zone" onClick={() => !preview && document.getElementById('fileInput').click()}>
                {preview ? (
                  <div style={{position: 'relative'}}>
                    <img src={preview} alt="Preview" className="preview-img" />
                    <button type="button" className="remove-btn" onClick={(e) => { e.stopPropagation(); setPreview(null); setImage(null); }} 
                      style={{position: 'absolute', top: 0, right: '25%', background: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', cursor: 'pointer', padding: '5px'}}>
                      <X size={14} />
                    </button>
                  </div>
                ) : (
                  <>
                    <Upload className="icon" size={32} style={{marginBottom: '10px'}} />
                    <p style={{fontSize: '13px', color: '#6b7280'}}>Cliquez pour uploader une image</p>
                  </>
                )}
                <input id="fileInput" type="file" accept="image/*" onChange={handleFile} style={{display: 'none'}} />
              </div>
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? "Chargement..." : <><Send size={18} /> Publier maintenant</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

